/* eslint-disable import/prefer-default-export */

// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
if (process.browser && !Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

// Returns the closest ancestor of the element (or the current element itself)
// which matches the selectors.
// If there isn't such an ancestor, it returns null.
export const findClosestNode = (element, selector) => {
  let el = element;
  if (Element.prototype.closest) {
    return el.closest(selector);
  }
  // Polyfill
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
  do {
    if (el.matches(selector)) {
      return el;
    }
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};

/**
 * traverses parent nodes of `element`, looking for a parent with
 * `position: relative`, and stopping at `stopElement`.
 *
 * @export
 * @param {HTMLElement} element start/target element
 * @param {HTMLElement} stopElement element to stop comparing at
 * @returns {HTMLElement} element that has position: relative (could be `stopElement`)
 */
export function findClosestPositionRelative(element, stopElement) {
  const isRelative = el => window.getComputedStyle(el).position === 'relative';

  let targetEl = element;

  do {
    targetEl = targetEl.parentNode;
  } while (targetEl !== stopElement && !isRelative(targetEl));

  return targetEl;
}

/* eslint-disable global-require */
// Wrapper to use native DOMParser and XMLSerializer in browser, and xmldom on
// server. NOTE: xmldom works in the browser, but using the native methods will
// reduce client bundle size (it also has to be excluded from Webpack, see there
// "browser" section of package.json).
export const DOMParser = process.browser
  ? window.DOMParser
  : require('xmldom').DOMParser;

export const XMLSerializer = process.browser
  ? window.XMLSerializer
  : require('xmldom').XMLSerializer;
